import { SortCriterion } from '@shinetools/lumen-react'

import { SuppliersTableSortCriterion } from '../types/suppliersTableSortCriterion'
import { isSuppliersTableSortKey } from './isSuppliersTableSortKey'

export const isSuppliersTableSortCriterion = (
  criterion: SortCriterion | undefined,
): criterion is SuppliersTableSortCriterion => criterion !== undefined && isSuppliersTableSortKey(criterion.key)
